import React, { useState, useEffect } from 'react';
import { Timeline, Button, Tag, Space, Empty, Spin } from '@bedrock/components';
import NoComments from '@bedrock/components/es/Empty/images/large/NoComments';
import PoPoJump from '@mpc/common/src/features/PoPoJump';
import { ChevronDown } from '@bedrock/icons-react';
import { SupplierRiskRemarkDto, enums } from '#services/api';
import TextAreaShow from '#components/SForm/SFormElement/TextAreaShow/index';
import './index.less';

type Props = {
  list?: SupplierRiskRemarkDto[];
  tabKey?: string;
  loading?: boolean;
};

const Index = (props: Props) => {
  const { list = [], tabKey, loading = false } = props;
  const [tempList, setTempList] = useState([]);
  const [showNoMore, setShowNoMore] = useState(false);

  useEffect(() => {
    const newList = [...list].splice(0, 4);
    setShowNoMore(false);
    setTempList(newList);
  }, [list]);

  const handleViewMore = () => {
    const newList = [...list].splice(0);
    setShowNoMore(true);
    setTempList(newList);
  };
  if (loading) {
    return (
      <div className="node-list-spin">
        <Spin tip="加载中..." />
      </div>
    );
  }

  return (
    <div className="note-list-container">
      <Timeline className="time-line-list">
        {tempList?.length ? (
          tempList.map((item, index) => {
            const tagText = enums.ApprovalNodeEnum.pick(
              item?.approval_node
            )?.name;
            return (
              <Timeline.Item
                title={
                  <Space size={8}>
                    <div>{item?.create_time}</div>
                    {tabKey === 'approval_opinion' && (
                      <div>
                        <Tag size="xSmall" text={tagText} color="light-brand" />
                      </div>
                    )}
                    {index === 0 && (
                      <div>
                        {' '}
                        <Tag size="xSmall" text={'最新'} color="light-green" />
                      </div>
                    )}
                  </Space>
                }
                desc={
                  <Space size={8}>
                    <div>{item?.operator?.name}</div>
                    <div>{item?.operator?.mail}</div>
                    <div>
                      <PoPoJump
                        className="popo-jump"
                        email={item?.operator?.mail}
                      />
                    </div>
                  </Space>
                }
              >
                <TextAreaShow
                  value={
                    item?.risk_remark ||
                    item?.supplier_comment ||
                    item?.approval_opinion
                  }
                />
              </Timeline.Item>
            );
          })
        ) : (
          <Empty
            imageNode={<NoComments />}
            description={<span style={{ fontSize: 14 }}>暂无数据</span>}
          />
        )}

        {!showNoMore && !!tempList.length && list.length >= 5 && (
          <Timeline.Item>
            <Button
              suffixIcon={<ChevronDown />}
              type="link"
              onClick={handleViewMore}
            >
              查看更多
            </Button>
          </Timeline.Item>
        )}
        {(showNoMore || (!!list.length && list.length <= 4)) && (
          <div className="no-more">- 暂无更多 -</div>
        )}
      </Timeline>
    </div>
  );
};

export default Index;
